export default {
    GENERATE_VARIABLES: {
        LOCAL: 'Local',
        OFFICE: 'office'
    },
    TYPE: {
        ORDER: "ORDER",
        ORDER_FREE: "ORDER_FREE",
        GET_FREE: "GET_FREE",
        BUY: "BUY",
        GET_INITIAL: "GET_INITIAL"
    },
    FILTER_TYPE: {
        DEFAULT_TYPE: {label: 'ALL', value: ''},
        ORDER: {label: "ORDER", value: "ORDER", strict: true},
        ORDER_FREE: {label: "ORDER_FREE", value: "FREE"},
        GET_FREE: {label: "GET_FREE", value: "FREE", disable: true},
        BUY: {label: "BUY", value: "BUY"}
    },
    MESSAGES: {
        ORDER: {title: 'ORDER_NUMBER.WINDOW.ORDER.TITLE', body: 'ORDER_NUMBER.WINDOW.ORDER.BODY'},
        ORDER_FREE: {title: 'ORDER_NUMBER.WINDOW.ORDER_FREE.TITLE', body: 'ORDER_NUMBER.WINDOW.ORDER_FREE.BODY'},
        BUY: {title: 'ORDER_NUMBER.WINDOW.BUY.TITLE', body: 'ORDER_NUMBER.WINDOW.BUY.BODY'},
        GET_FREE: {title: 'ORDER_NUMBER.WINDOW.GET_FREE.TITLE'},
        NUMBER_NOT_AVAILABLE: {title: "ORDER_NUMBER.NUMBER_NOT_AVAILABLE_MODAL.TITLE", body: "ORDER_NUMBER.NUMBER_NOT_AVAILABLE_MODAL.BODY", buttonText: "ORDER_NUMBER.NUMBER_NOT_AVAILABLE_MODAL.BUTTON"}
    },
    LABEL: "ORDER_NUMBER.WINDOW.LABEL",
    ENTITLED_FOR_FREE: "FREE_CHOSEN"
}
